import { useState, useRef } from "react";
import { useApp } from "../context/AppContext";
import { parseCSV, buildClusters, mergeClusters, parsePastedRows } from "../utils/csv";
import Badge from "../components/Badge";
import { Icons } from "../components/Icons";

export default function DetailView() {
  const { proj, activeId, getStore, setStore, dataRef, projects, setProjects, apiFetch,
    saveClusters, saveContent, saveStructure, saveSemClusters, saveLinks,
    flash, setView, view, dark, setDark, t, card, inp, btnP, btnG, btnSm, stitle, muted, th, td,
    userRole, currentUser, loadProjectData, openP, infoId, setInfoId, setActiveId } = useApp();
  if (!proj) return null;
  const store = getStore(activeId);
  const [comp, setComp] = useState(proj.competitors?.join("\n") || "");
  const [err, setErr] = useState("");
  const [drag, setDrag] = useState(false);
  const [page, setPage] = useState(0);
  const [mode, setMode] = useState("replace"); // "replace" | "merge"
  const [pasteText, setPasteText] = useState("");
  const [pasteMode, setPasteMode] = useState(false);
  const [mergePasteMode, setMergePasteMode] = useState(false);
  const fRef = useRef();
  const mergeRef = useRef();
  const perPage = 40;

  const saveComp = () => {
    const l = comp.split("\n").map(s => s.trim()).filter(Boolean);
    setProjects(ps => ps.map(p => p.id === activeId ? { ...p, competitors: l } : p));
    apiFetch(`/api/projects/${activeId}`, { method: "PUT", body: JSON.stringify({ competitors: l }) }).catch(() => {});
    flash("Збережено");
  };

  const handleFile = (file, mergeMode = false) => {
    setErr("");
    const processText = (text) => {
      const rows = parseCSV(text);
      if (rows === null) { setErr("Не знайдено колонки keyword, frequency, url"); return; }
      if (!rows.length) { setErr("Немає рядків"); return; }

      if (mergeMode) {
        // Merge into existing clusters
        const existing = getStore(activeId).clusters || [];
        const { clusters, newUrls, updatedUrls } = mergeClusters(existing, rows);
        const allRows = clusters.flatMap(c => (c.keywords || []).map(k => ({ keyword: k.keyword, frequency: k.frequency, url: c.url })));
        setStore(activeId, { ...getStore(activeId), rows: allRows, clusters });
        setProjects(ps => ps.map(p => p.id === activeId ? { ...p, cc: clusters.length, rc: allRows.length } : p));
        apiFetch(`/api/projects/${activeId}`, { method: "PUT", body: JSON.stringify({ cc: clusters.length }) }).catch(() => {});
        saveClusters(activeId, clusters);
        setPage(0);
        flash(`Доповнено: +${newUrls} нових URL, ${updatedUrls} оновлено, ${rows.length} ключів. Всього: ${clusters.length} кластерів`);
      } else {
        // Replace all
        const clusters = buildClusters(rows);
        setStore(activeId, { ...getStore(activeId), rows, clusters });
        setProjects(ps => ps.map(p => p.id === activeId ? { ...p, cc: clusters.length, rc: rows.length } : p));
        apiFetch(`/api/projects/${activeId}`, { method: "PUT", body: JSON.stringify({ cc: clusters.length }) }).catch(() => {});
        saveClusters(activeId, clusters);
        setPage(0);
        flash(`${rows.length} ключів → ${clusters.length} кластерів`);
      }
    };
    // Try UTF-8 first, fallback to Windows-1251
    const reader = new FileReader();
    reader.onload = ev => {
      const text = ev.target.result;
      if (/\ufffd|����/.test(text)) {
        const reader2 = new FileReader();
        reader2.onload = ev2 => processText(ev2.target.result);
        reader2.readAsText(file, "windows-1251");
      } else {
        processText(text);
      }
    };
    reader.readAsText(file, "utf-8");
  };

  const handlePasteImport = (mergeMode = false) => {
    setErr("");
    if (!pasteText.trim()) { setErr("Порожній текст"); return; }
    const { rows, skipped, noUrl } = parsePastedRows(pasteText);
    if (!rows.length) { setErr(`Не вдалося розпарсити (${skipped} без ключа/частотності, ${noUrl} без URL). Формат: ключ [TAB] частотність [TAB] url`); return; }
    if (noUrl) flash(`⚠️ ${noUrl} ключів без URL — пропущено (не додано на головну)`);

    if (mergeMode) {
      const existing = getStore(activeId).clusters || [];
      const { clusters, newUrls, updatedUrls } = mergeClusters(existing, rows);
      const allRows = clusters.flatMap(c => (c.keywords || []).map(k => ({ keyword: k.keyword, frequency: k.frequency, url: c.url })));
      setStore(activeId, { ...getStore(activeId), rows: allRows, clusters });
      setProjects(ps => ps.map(p => p.id === activeId ? { ...p, cc: clusters.length, rc: allRows.length } : p));
      apiFetch(`/api/projects/${activeId}`, { method: "PUT", body: JSON.stringify({ cc: clusters.length }) }).catch(() => {});
      saveClusters(activeId, clusters);
      setPage(0);
      flash(`Доповнено: +${newUrls} нових URL, ${updatedUrls} оновлено, ${rows.length} ключів`);
    } else {
      const clusters = buildClusters(rows);
      setStore(activeId, { ...getStore(activeId), rows, clusters });
      setProjects(ps => ps.map(p => p.id === activeId ? { ...p, cc: clusters.length, rc: rows.length } : p));
      apiFetch(`/api/projects/${activeId}`, { method: "PUT", body: JSON.stringify({ cc: clusters.length }) }).catch(() => {});
      saveClusters(activeId, clusters);
      setPage(0);
      flash(`${rows.length} ключів → ${clusters.length} кластерів`);
    }
    setPasteText("");
    setPasteMode(false);
  };

  const cls = store.clusters || [];
  const readyN = cls.filter(c => c.status === "READY").length;
  const totalPg = Math.ceil(cls.length / perPage);
  const pageCls = cls.slice(page * perPage, (page + 1) * perPage);

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 18 }}>
        <h2 style={{ fontSize: 20, fontWeight: 700 }}>{Icons.fileText(16)} Загрузка семантики</h2>
        <span style={{ background: dark ? "#252535" : "#f3f4f6", padding: "3px 10px", borderRadius: 10, fontSize: 12, color: t.textMuted }}>{proj.domain}</span>
      </div>

      <div style={card}>
        <p style={stitle}>Конкуренти</p>
        <p style={{ ...muted, marginTop: -8, marginBottom: 8 }}>Домени конкурентів — використовуються при розширенні структури для gap-аналізу</p>
        <textarea value={comp} onChange={e => setComp(e.target.value)} onBlur={saveComp} placeholder={"competitor1.com\ncompetitor2.com\ncompetitor3.com"} rows={3} style={{ ...inp, resize: "vertical", fontFamily: "monospace", fontSize: 13 }} />
        {comp.trim() && <p style={{ fontSize: 11, color: "#10b981", marginTop: 4 }}>{comp.split("\n").filter(s => s.trim()).length} конкурентів</p>}
      </div>

      <div style={card}>
        <p style={stitle}>Завантаження семантики</p>
        <div style={{ display: "flex", gap: 12, justifyContent: "center", marginBottom: pasteMode ? 12 : 0 }}>
          <div
            style={{ border: `2px dashed ${drag ? "#6366f1" : (dark ? "#444" : "#ccc")}`, borderRadius: 12, padding: "20px 24px", textAlign: "center", cursor: "pointer", background: drag ? (dark ? "rgba(99,102,241,0.1)" : "#f5f3ff") : (dark ? "#151520" : "#fafafa"), flex: 1, maxWidth: 300, transition: "all .15s" }}
            onDragOver={e => { e.preventDefault(); setDrag(true); }} onDragLeave={() => setDrag(false)}
            onDrop={e => { e.preventDefault(); setDrag(false); e.dataTransfer.files[0] && handleFile(e.dataTransfer.files[0], false); }}
            onClick={() => fRef.current?.click()}>
            <div style={{ fontSize: 28 }}>{Icons.fileText(28)}</div>
            <p style={{ fontWeight: 500, marginTop: 4 }}>Завантажити CSV/TSV файл</p>
            <p style={muted}>keyword, frequency, url</p>
            <input ref={fRef} type="file" accept=".csv,.tsv,.txt" hidden onChange={e => { if (e.target.files[0]) { handleFile(e.target.files[0], false); e.target.value = ""; } }} />
          </div>
          <div
            style={{ border: `2px dashed ${pasteMode ? "#6366f1" : (dark ? "#444" : "#ccc")}`, borderRadius: 12, padding: "20px 24px", textAlign: "center", cursor: "pointer", background: dark ? "#151520" : "#fafafa", flex: 1, maxWidth: 300, transition: "all .15s" }}
            onClick={() => { setPasteMode(!pasteMode); setMergePasteMode(false); }}>
            <div style={{ fontSize: 28 }}>{Icons.clipboard(28)}</div>
            <p style={{ fontWeight: 500, marginTop: 4 }}>Вставити з таблиці</p>
            <p style={muted}>Скопіюйте з Excel / Google Sheets</p>
          </div>
        </div>
        {pasteMode && (
          <div style={{ marginTop: 12, textAlign: "left" }}>
            <textarea value={pasteText} onChange={e => setPasteText(e.target.value)} rows={10}
              placeholder={"Скопіюйте рядки з таблиці та вставте сюди (Ctrl+V).\nФормат: ключ [TAB] частотність [TAB] url\n\nкупити диван\t1200\thttps://site.com/divany\nдиван кутовий\t800\thttps://site.com/divany\nліжко двоспальне\t500\thttps://site.com/lizhka"}
              style={{ width: "100%", padding: 10, fontSize: 12, fontFamily: "monospace", borderRadius: 8, border: `1px solid ${dark ? "#333" : "#ccc"}`, background: dark ? "#0f0f14" : "#fff", color: dark ? "#e0e0e0" : "#333", resize: "vertical", boxSizing: "border-box" }} autoFocus />
            <div style={{ display: "flex", gap: 8, marginTop: 8, justifyContent: "center" }}>
              <button style={{ ...btnP, fontSize: 12 }} onClick={() => handlePasteImport(false)} disabled={!pasteText.trim()}>Замінити семантику</button>
              {cls.length > 0 && (
                <button style={{ ...btnG, fontSize: 12 }} onClick={() => handlePasteImport(true)} disabled={!pasteText.trim()}>{Icons.plus(14)} Доповнити</button>
              )}
              <button style={btnSm} onClick={() => { setPasteMode(false); setPasteText(""); }}>Скасувати</button>
            </div>
          </div>
        )}
        {cls.length > 0 && (
          <div
            style={{ border: `2px dashed ${dark ? "#065f46" : "#bbf7d0"}`, borderRadius: 12, padding: "16px", textAlign: "center", background: dark ? "rgba(16,185,129,0.05)" : "#f0fdf4", marginTop: 12, transition: "all .15s" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
              <span style={{ fontSize: 20 }}>{Icons.plus(20)}</span>
              <div>
                <p style={{ fontWeight: 600, fontSize: 13, color: "#10b981", margin: 0 }}>Доповнити семантику</p>
                <p style={{ fontSize: 11, color: t.textMuted, margin: "2px 0 0" }}>Додає нові ключі та URL, зберігає існуючі мета-теги і контент</p>
              </div>
            </div>
            <div style={{ display: "flex", gap: 8, justifyContent: "center", marginTop: 10 }}>
              <button style={{ ...btnG, fontSize: 12 }} onClick={() => mergeRef.current?.click()}>{Icons.fileText(14)} Файл</button>
              <button style={{ ...btnG, fontSize: 12 }} onClick={() => { setMergePasteMode(v => !v); setPasteMode(false); }}>{Icons.clipboard(14)} Вставити колонки</button>
            </div>
            <input ref={mergeRef} type="file" accept=".csv,.tsv,.txt" hidden onChange={e => { if (e.target.files[0]) { handleFile(e.target.files[0], true); e.target.value = ""; } }} />
          </div>
        )}
        {mergePasteMode && cls.length > 0 && (
          <div style={{ marginTop: 10, textAlign: "left" }}>
            <textarea value={pasteText} onChange={e => setPasteText(e.target.value)} rows={9}
              placeholder={"Скопіюйте рядки з таблиці та вставте сюди (Ctrl+V) — режим ДОПОВНЕННЯ.\nФормат: ключ [TAB] частотність [TAB] url\n\nкупити диван\t1200\thttps://site.com/divany\nдиван кутовий\t800\thttps://site.com/divany"}
              style={{ width: "100%", padding: 10, fontSize: 12, fontFamily: "monospace", borderRadius: 8, border: `1px solid ${dark ? "#333" : "#ccc"}`, background: dark ? "#0f0f14" : "#fff", color: dark ? "#e0e0e0" : "#333", resize: "vertical", boxSizing: "border-box" }} autoFocus />
            <div style={{ display: "flex", gap: 8, marginTop: 8, justifyContent: "center" }}>
              <button style={{ ...btnG, fontSize: 12 }} onClick={() => { handlePasteImport(true); setMergePasteMode(false); }} disabled={!pasteText.trim()}>{Icons.plus(14)} Доповнити зі вставки</button>
              <button style={btnSm} onClick={() => { setMergePasteMode(false); setPasteText(""); }}>Скасувати</button>
            </div>
          </div>
        )}
        {err && <p style={{ color: "#dc2626", marginTop: 8, fontSize: 13 }}>{Icons.xCircle(14, "#dc2626")} {err}</p>}
        {cls.length > 0 && <p style={{ color: "#16a34a", marginTop: 10, fontSize: 13 }}>{Icons.checkCircle(14, "#16a34a")} {(store.rows || []).length} ключів → {cls.length} кластерів ({readyN} готові)</p>}
      </div>

      {cls.length > 0 && (
        <div style={card}>
          <div style={{ display: "flex", alignItems: "center", marginBottom: 12 }}>
            <p style={{ ...stitle, margin: 0 }}>Кластеры ({cls.length})</p>
            <button style={{ ...btnP, marginLeft: "auto" }} onClick={() => setView("dashboard")}>{Icons.check(14)} К модулям</button>
          </div>
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
              <thead><tr>
                <th style={th}>URL</th><th style={{ ...th, width: 55 }}>Кл.</th><th style={th}>ВЧ-ключ</th><th style={{ ...th, width: 90 }}>Статус</th>
              </tr></thead>
              <tbody>{pageCls.map(c => (
                <tr key={c.id}>
                  <td style={td}><span style={{ fontSize: 11, color: "#888", wordBreak: "break-all" }}>{c.url}</span></td>
                  <td style={{ ...td, textAlign: "center", fontWeight: 600 }}>{c.allCount}</td>
                  <td style={td}><b>{c.hfKeyword}</b> <span style={{ fontSize: 11, color: "#aaa" }}>({c.hfFreq})</span></td>
                  <td style={td}><Badge st={c.status} /></td>
                </tr>
              ))}</tbody>
            </table>
          </div>
          {totalPg > 1 && (
            <div style={{ display: "flex", justifyContent: "center", gap: 8, marginTop: 12 }}>
              <button style={btnSm} disabled={page === 0} onClick={() => setPage(page - 1)}>←</button>
              <span style={{ fontSize: 12, lineHeight: "28px" }}>{page + 1}/{totalPg}</span>
              <button style={btnSm} disabled={page >= totalPg - 1} onClick={() => setPage(page + 1)}>→</button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

// ═══ MODULES VIEW (intermediate page) ═══
